import { http } from './http-utils';
export const getSessions = (all = false) => {
    return http({
        endpoint: `/sessions${all ? '?all=1' : ''}`
    });
};
export const saveSessions = (sessions) => {
    return http({
        method: 'POST',
        endpoint: '/sessions',
        data: {
            sessions
        }
    });
};
export const openSession = (sessionId, open) => {
    return http({
        method: 'PUT',
        endpoint: `/sessions/${sessionId}/open/${open}`,
    });
};
export const deleteSession = (sessionId) => {
    return http({
        method: 'DELETE',
        endpoint: `/sessions/${sessionId}`,
    });
};
export const getRegistrationsBySession = (sessionId) => {
    return http({
        endpoint: `/sessions/${sessionId}/registrations`,
    });
};
export const getNumberOfRegistrationsBySession = () => {
    return http({
        endpoint: `/sessions/numberOfRegistrations`,
    });
};
export const saveRegistration = (registration) => {
    return http({
        method: 'POST',
        endpoint: '/registrations',
        data: registration
    });
};
export const deleteRegistration = (registrationId) => {
    return http({
        method: 'DELETE',
        endpoint: `/registrations/${registrationId}`,
    });
};
export const getNextSessions = async (all = false) => {
    const sessionsResult = await getSessions(all);
    const registrationsResult = await getNumberOfRegistrationsBySession();
    const sessions = sessionsResult.status === 'OK' ? sessionsResult.sessions : [];
    const numberOfRegistrationsBySession = registrationsResult.status === 'OK' ? registrationsResult.counts : [];
    const placesBySession = sessions.reduce((acc, session) => {
        const nbRegistrations = numberOfRegistrationsBySession[session._id];
        acc.registered[session._id] = ((nbRegistrations === null || nbRegistrations === void 0 ? void 0 : nbRegistrations.adults) || 0) + ((nbRegistrations === null || nbRegistrations === void 0 ? void 0 : nbRegistrations.children) || 0);
        acc.availables[session._id] = session.nbPlaces > 0 ? session.nbPlaces - (acc.registered[session._id]) : Number.MAX_VALUE;
        return acc;
    }, { registered: [], availables: [] });
    return {
        sessions,
        numberOfRegistrationsBySession,
        registeredPlacesBySession: placesBySession.registered,
        availablePlacesBySession: placesBySession.availables
    };
};
